module.exports = __webpack_public_path__ + "images/Forms.c7f5e982.webp";